// ============================================================================
// ITALIAN TRANSLATIONS - CHAPTER 6: LE MISSIONI DI PAOLO
// ============================================================================
// Livelli 66-78 (13 livelli, 39 domande)

export const chapter6Translations = {
  name: "Le Missioni di Paolo",
  description: "Fino agli estremi confini della terra...",
  
  spiritualWisdom: {
    principle: "Il Vangelo è per tutte le nazioni e deve essere annunciato al mondo intero",
    scripture: "Andate e fate discepoli tutti i popoli (Matteo 28:19)",
    application: "Ogni cristiano è chiamato ad essere testimone di Cristo dove Dio lo pone"
  },
  
  levels: {
    66: {
      name: "Primo Viaggio Missionario",
      challenge: "Mettetemi da parte Barnaba e Saulo per l'opera alla quale li ho chiamati...",
      easy: {
        question: "Chi accompagnò Paolo nel suo primo viaggio?",
        options: ["Pietro", "Barnaba", "Sila", "Timoteo"],
        hint: "Il 'figlio della consolazione'",
        funFact: "👥 Barnaba aveva accolto Paolo dopo la sua conversione - partnership provvidenziale!"
      },
      medium: {
        question: "Da quale città partirono per la loro missione?",
        options: [
          "Gerusalemme",
          "Antiochia di Siria",
          "Tarso",
          "Damasco"
        ],
        hint: "La prima chiesa mista di giudei e pagani",
        funFact: "🚢 Antiochia: porto di partenza dell'evangelizzazione del mondo occidentale!"
      },
      hard: {
        question: "Cosa rivela questo primo viaggio sulla strategia missionaria?",
        options: [
          "Bisogna restare nella propria regione",
          "Il Vangelo trascende tutte le frontiere culturali",
          "Solo i giudei possono essere salvati",
          "La missione è facoltativa"
        ],
        hint: "Si tratta dell'universalità del messaggio",
        funFact: "🌊 Attraversare il Mediterraneo = fare il passo verso l'evangelizzazione mondiale!"
      }
    },
    
    67: {
      name: "A Cipro con Elimas",
      challenge: "Uomo pieno di ogni frode e di ogni malizia, figlio del diavolo...",
      easy: {
        question: "Quale mago si oppose a Paolo a Cipro?",
        options: ["Simone", "Elimas", "Apollo", "Alessandro"],
        hint: "Un falso profeta che voleva allontanare il proconsole",
        funFact: "🪄 Primo scontro diretto tra il Vangelo e la magia!"
      },
      medium: {
        question: "Cosa fece Paolo a Elimas per punirlo?",
        options: [
          "Lo cacciò",
          "Lo rese temporaneamente cieco",
          "Lo ignorò",
          "Dibatté con lui"
        ],
        hint: "Una cecità temporanea per aprirgli gli occhi spirituali",
        funFact: "👁️ Ironia divina: chi accecava le anime diventa temporaneamente cieco!"
      },
      hard: {
        question: "Come illustra questo episodio la potenza del Vangelo?",
        options: [
          "La violenza è necessaria",
          "La verità divina si impone di fronte alla menzogna",
          "Bisogna combattere tutti i maghi",
          "Paolo era vendicativo"
        ],
        hint: "Si tratta dell'autorità divina di fronte all'impostura",
        funFact: "⚡ Il proconsole crede vedendo la potenza divina - dimostrazione efficace!"
      }
    },

    68: {
      name: "Ad Antiochia di Pisidia",
      challenge: "A voi per primi bisognava annunciare la parola di Dio...",
      easy: {
        question: "Dove predicava Paolo arrivando in una città?",
        options: [
          "Sulla piazza pubblica",
          "Prima nella sinagoga",
          "Dai ricchi",
          "Nei templi pagani"
        ],
        hint: "Iniziava sempre dal suo popolo",
        funFact: "🕍 Strategia missionaria: prima ai giudei, poi ai pagani!"
      },
      medium: {
        question: "Come reagirono i giudei al messaggio di Paolo?",
        options: [
          "Tutti lo accettarono",
          "Furono divisi: alcuni credettero, altri si opposero",
          "Rimasero indifferenti",
          "Lo espulsero immediatamente"
        ],
        hint: "Divisione classica di fronte al Vangelo",
        funFact: "⚖️ Il Vangelo divide sempre: accettazione o rifiuto, non indifferenza!"
      },
      hard: {
        question: "Perché Paolo si rivolge ai pagani?",
        options: [
          "Preferiva i pagani",
          "Il rifiuto dei giudei apre la porta alle nazioni",
          "Era più facile",
          "Abbandonava la sua missione"
        ],
        hint: "Si tratta del compimento profetico",
        funFact: "🚪 'Luce delle nazioni' - profezia di Isaia compiuta da Paolo!"
      }
    },

    69: {
      name: "Guarigione a Listra",
      challenge: "Gli dèi in forma umana sono scesi fra noi!",
      easy: {
        question: "Cosa guarì Paolo a Listra?",
        options: [
          "Un cieco",
          "Un paralitico dalla nascita",
          "Un sordomuto",
          "Un lebbroso"
        ],
        hint: "Qualcuno che non aveva mai camminato",
        funFact: "🦵 Miracolo spettacolare: 'Alzati diritto sui tuoi piedi!' - fede guaritrice!"
      },
      medium: {
        question: "Per chi la folla prese Paolo e Barnaba?",
        options: [
          "Re",
          "Dèi (Giove e Mercurio)",
          "Maghi",
          "Profeti"
        ],
        hint: "Divinità del pantheon greco",
        funFact: "⚡ Barnaba = Giove (imponente), Paolo = Mercurio (oratore) - malinteso culturale!"
      },
      hard: {
        question: "Come reagì Paolo a questa adorazione idolatra?",
        options: [
          "Accetta gli onori",
          "Strappa le sue vesti e predica il vero Dio",
          "Tace per cortesia",
          "Approfitta della situazione"
        ],
        hint: "Rifiuto totale dell'idolatria",
        funFact: "👔 Strappare le vesti = orrore giudaico davanti all'idolatria - integrità totale!"
      }
    },

    70: {
      name: "Lapidazione e Risurrezione",
      challenge: "Mentre i discepoli gli facevano cerchio attorno, egli si alzò ed entrò in città...",
      easy: {
        question: "Cosa fecero gli abitanti di Listra a Paolo?",
        options: [
          "Lo imprigionarono",
          "Lo lapidarono",
          "Lo esiliarono",
          "Lo crocifissero"
        ],
        hint: "Il castigo tradizionale giudaico",
        funFact: "🪨 Da 'dio' a 'morto' in un giorno - incostanza della folla umana!"
      },
      medium: {
        question: "Cosa fece Paolo dopo essere stato lapidato?",
        options: [
          "Fuggì dalla città",
          "Si nascose",
          "Si alzò e rientrò in città",
          "Andò all'ospedale"
        ],
        hint: "Coraggio soprannaturale dopo la morte presunta",
        funFact: "💪 Risurrezione miracolosa o guarigione divina - coraggio incredibile!"
      },
      hard: {
        question: "Cosa rivela questa persecuzione sul costo della testimonianza?",
        options: [
          "Bisogna evitare i conflitti",
          "Testimoniare per Cristo può costare la vita",
          "Paolo era imprudente",
          "La persecuzione è inutile"
        ],
        hint: "Si tratta del prezzo della testimonianza autentica",
        funFact: "✝️ 'È necessario attraversare molte tribolazioni' - realismo di Paolo!"
      }
    },

    71: {
      name: "Il Concilio di Gerusalemme",
      challenge: "Se non vi fate circoncidere, non potete essere salvati...",
      easy: {
        question: "Quale dibattito importante ebbe luogo al concilio di Gerusalemme?",
        options: [
          "Il battesimo",
          "La circoncisione dei pagani convertiti",
          "Il giorno del sabato",
          "Le offerte"
        ],
        hint: "Bisognava diventare giudei per essere cristiani?",
        funFact: "✂️ Prima crisi importante: cristianesimo o giudeo-cristianesimo?"
      },
      medium: {
        question: "Quale fu la decisione finale del concilio?",
        options: [
          "Circoncisione obbligatoria",
          "Libertà per i pagani con alcune raccomandazioni",
          "Separazione totale dai giudei",
          "Rinvio della decisione"
        ],
        hint: "Apertura ai pagani senza vincolo maggiore",
        funFact: "🆓 Rivoluzione storica: il Vangelo libero dalla legge mosaica!"
      },
      hard: {
        question: "Quale importanza ha questo concilio per la Chiesa universale?",
        options: [
          "Evento minore",
          "Stabilisce l'universalità della salvezza per sola fede",
          "Divide la Chiesa",
          "Rafforza il legalismo"
        ],
        hint: "Si tratta del fondamento della Chiesa universale",
        funFact: "🌍 Senza questa decisione, il cristianesimo sarebbe rimasto una setta giudaica!"
      }
    },

    72: {
      name: "Secondo Viaggio: Timoteo",
      challenge: "Paolo volle che partisse con lui e lo circoncise a causa dei giudei...",
      easy: {
        question: "Chi si unì a Paolo come giovane collaboratore?",
        options: ["Marco", "Luca", "Timoteo", "Tito"],
        hint: "Il 'figlio diletto' di Paolo",
        funFact: "👦 Timoteo: giovane prodigio diventato braccio destro di Paolo - mentorship riuscita!"
      },
      medium: {
        question: "Perché Paolo circoncise Timoteo nonostante la libertà acquisita?",
        options: [
          "Per obbligo legale",
          "Per strategia missionaria presso i giudei",
          "Per tradizione",
          "Per errore"
        ],
        hint: "Saggezza pratica per evitare ostacoli",
        funFact: "🎯 Libertà con saggezza: 'Farsi tutto a tutti per guadagnarne alcuni'!"
      },
      hard: {
        question: "Come illustra questo atteggiamento la flessibilità missionaria?",
        options: [
          "Paolo era incostante",
          "Adattava il suo metodo senza compromettere il Vangelo",
          "Cedeva alla pressione",
          "Era ipocrita"
        ],
        hint: "Si tratta di saggezza contestuale",
        funFact: "⚖️ Principi fermi, metodi flessibili - arte della testimonianza efficace!"
      }
    },

    73: {
      name: "La Visione dell'Uomo Macedone",
      challenge: "Passa in Macedonia e aiutaci!",
      easy: {
        question: "Cosa vide Paolo nella sua visione notturna?",
        options: [
          "Un angelo",
          "Un uomo della Macedonia che lo chiamava",
          "Gesù che gli parlava",
          "Una grande luce"
        ],
        hint: "Una chiamata d'aiuto dall'Europa",
        funFact: "🌉 Visione decisiva: il Vangelo attraversa in Europa - svolta storica!"
      },
      medium: {
        question: "Quale fu la prima città europea evangelizzata?",
        options: [
          "Atene",
          "Corinto",
          "Filippi",
          "Tessalonica"
        ],
        hint: "Colonia romana in Macedonia",
        funFact: "🏛️ Filippi: prima chiesa europea - continente trasformato per sempre!"
      },
      hard: {
        question: "Cosa simboleggia questa visione per la storia del cristianesimo?",
        options: [
          "Un sogno ordinario",
          "L'espansione provvidenziale verso l'Occidente",
          "Un'allucinazione",
          "Un cambio di piano"
        ],
        hint: "Si tratta della Provvidenza che dirige la storia",
        funFact: "🗺️ Senza questa visione, l'Europa potrebbe essere rimasta pagana - piano divino!"
      }
    },

    74: {
      name: "Lidia, Prima Convertita Europea",
      challenge: "Il Signore aprì il cuore di Lidia per renderla attenta...",
      easy: {
        question: "Qual era il mestiere di Lidia?",
        options: [
          "Fornaio",
          "Commerciante di porpora",
          "Tessitrice",
          "Vasaia"
        ],
        hint: "Commercio di lusso dell'epoca",
        funFact: "🟣 Porpora = colore regale molto costoso - Lidia era prospera!"
      },
      medium: {
        question: "Dove Paolo incontrò Lidia?",
        options: [
          "Al mercato",
          "Sulla riva del fiume durante una preghiera",
          "A casa sua",
          "Nella sinagoga"
        ],
        hint: "Un luogo di preghiera all'aperto",
        funFact: "🏞️ Nessuna sinagoga a Filippi - preghiera in riva all'acqua secondo la tradizione!"
      },
      hard: {
        question: "Cosa rivela la conversione di Lidia sull'opera divina?",
        options: [
          "Era predisposta",
          "Dio apre i cuori preparati a ricevere la sua Parola",
          "Era una coincidenza",
          "Paolo era persuasivo"
        ],
        hint: "Si tratta dell'azione divina nella conversione",
        funFact: "💝 'Il Signore aprì il suo cuore' - Dio prepara e apre le anime!"
      }
    },

    75: {
      name: "Prigione a Filippi",
      challenge: "Verso mezzanotte Paolo e Sila pregavano e cantavano inni a Dio...",
      easy: {
        question: "Perché Paolo e Sila furono imprigionati?",
        options: [
          "Furto",
          "Disturbo dell'ordine pubblico cacciando un demonio",
          "Bestemmia",
          "Rivolta"
        ],
        hint: "Guarigione di una schiava indovina",
        funFact: "💸 Liberare un'anima costa caro ai suoi sfruttatori - persecuzione economica!"
      },
      medium: {
        question: "Cosa fecero Paolo e Sila in prigione?",
        options: [
          "Si lamentarono",
          "Pregavano e cantavano",
          "Preparavano la loro difesa",
          "Dormirono"
        ],
        hint: "Lode nonostante le catene",
        funFact: "🎵 Canti di lode a mezzanotte in prigione - fede incrollabile che impressiona!"
      },
      hard: {
        question: "Come trasformò il loro atteggiamento la situazione?",
        options: [
          "Non ebbe alcun effetto",
          "Convertì il carceriere dopo il terremoto",
          "Irritò le guardie",
          "Li rese pazzi"
        ],
        hint: "Testimonianza potente con l'esempio",
        funFact: "🌍 Terremoto + testimonianza = conversione del carceriere e della sua famiglia!"
      }
    },

    76: {
      name: "Ad Atene: L'Areopago",
      challenge: "Ciò che voi adorate senza conoscere, io ve lo annuncio...",
      easy: {
        question: "A quale altare Paolo fece riferimento ad Atene?",
        options: [
          "Al dio Zeus",
          "Al dio sconosciuto",
          "Ad Apollo",
          "Ad Atena"
        ],
        hint: "Un'iscrizione misteriosa che servì da punto di partenza",
        funFact: "🏛️ 'Al dio sconosciuto' - punto di contatto geniale con la filosofia greca!"
      },
      medium: {
        question: "Davanti a chi predicò Paolo ad Atene?",
        options: [
          "La folla ordinaria",
          "I filosofi epicurei e stoici all'Areopago",
          "I sacerdoti dei templi",
          "L'imperatore romano"
        ],
        hint: "L'élite intellettuale greca",
        funFact: "🧠 Areopago = Harvard antica - Paolo davanti ai più grandi pensatori!"
      },
      hard: {
        question: "Quale fu la reazione degli ateniesi alla risurrezione?",
        options: [
          "Accettazione unanime",
          "Divisione: scherno di alcuni, interesse di altri",
          "Ira generale",
          "Indifferenza totale"
        ],
        hint: "Reazione tipica degli intellettuali a questo mistero",
        funFact: "🤔 Risurrezione = pietra d'inciampo per l'intelligenza umana orgogliosa!"
      }
    },

    77: {
      name: "Corinto: Paolo Fabbricante di Tende",
      challenge: "Si trattenne con loro e lavorava, poiché erano fabbricanti di tende...",
      easy: {
        question: "Quale mestiere praticava Paolo per guadagnarsi da vivere?",
        options: [
          "Pescatore",
          "Fabbricante di tende",
          "Scriba",
          "Mercante"
        ],
        hint: "Mestiere manuale che aveva imparato",
        funFact: "⛺ Paolo: apostolo-artigiano - dignità del lavoro manuale tra i cristiani!"
      },
      medium: {
        question: "Da chi alloggiò Paolo a Corinto?",
        options: [
          "In una locanda",
          "Da Aquila e Priscilla",
          "Dal governatore",
          "Nella sinagoga"
        ],
        hint: "Una coppia di fabbricanti di tende come lui",
        funFact: "👫 Aquila e Priscilla: coppia missionaria modello - ospitalità cristiana!"
      },
      hard: {
        question: "Perché Paolo lavorava con le sue mani?",
        options: [
          "Solo per necessità finanziaria",
          "Per non essere di peso e autenticare la sua testimonianza",
          "Per tradizione familiare",
          "Perché amava quel mestiere"
        ],
        hint: "Si tratta di indipendenza e credibilità",
        funFact: "💼 Autonomia finanziaria = libertà di parola - Paolo non dipendeva da nessuno!"
      }
    },

    78: {
      name: "Rivolta a Efeso",
      challenge: "Grande è Diana degli Efesini!",
      easy: {
        question: "Chi provocò la rivolta contro Paolo a Efeso?",
        options: [
          "Le autorità romane",
          "Demetrio l'orefice e gli artigiani",
          "I filosofi",
          "I sacerdoti giudei"
        ],
        hint: "Quelli che fabbricavano templi di Diana",
        funFact: "🏛️ Primo sciopero della storia: il Vangelo minaccia l'economia idolatra!"
      },
      medium: {
        question: "Quanto tempo Paolo insegnò a Efeso?",
        options: [
          "6 mesi",
          "1 anno",
          "2 anni",
          "3 anni"
        ],
        hint: "Il suo soggiorno missionario più lungo",
        funFact: "📅 3 anni di insegnamento intensivo - Efeso divenne centro missionario importante!"
      },
      hard: {
        question: "Cosa rivela questa rivolta sull'impatto sociale del Vangelo?",
        options: [
          "Il Vangelo non cambia nulla",
          "Trasforma le strutture economiche e sociali",
          "Riguarda solo la religione",
          "Evita i conflitti"
        ],
        hint: "Si tratta di trasformazione sociale profonda",
        funFact: "💰 Quando il Vangelo progredisce, gli idoli perdono il loro mercato - impatto economico!"
      }
    }
  }
};

export default chapter6Translations;
